module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Hi Hat Accent-6fa792142b47fab1cabb9b19577f1bec.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Hi Hat Accent.mp3
// module id = 57
// module chunks = 0